import React from "react"

const SvgArrow = (props) => (
  <svg viewBox="0 0 18 18" {...props}>
    <path d="M12.314 3.293L18.021 9l-5.707 5.707-1.414-1.414L14.192 10H0V8h14.192L10.9 4.707l1.414-1.414z" fillRule="evenodd" />
  </svg>
)

export default SvgArrow
